import { ICONS } from '../../../_helpers/icons.constants';
export interface InfoTextConfig {
  iconSrc?: string; //Path to the icon shown on the left
  iconAlt?: string;
  text?: string;
  iconClass?: string;//Optional CSS class to apply to the icon img.
  /**
   * If true, the component expects the parent to project a custom icon into
   * the `[info-icon]` slot (for example an SVG or an Angular icon component).
   * When projected content is present the `iconSrc` is ignored.
   */
  useProjectedIcon?: boolean;
}

export const DEFAULT_INFOTEXT_CONFIG: InfoTextConfig = {
  iconSrc: ICONS.INFO,
  iconAlt: 'Info',
  text: '',
  iconClass: '',
  useProjectedIcon: false
}